module.exports = __webpack_public_path__ + "img/W-V18.2e8b56c2.jpg";